import { api } from './api';

// Platform-wide totals and growth metrics
export const getPlatformOverview = async () => {
  const response = await api.get('/admin/overview');
  return response.data;
};

// List every org with usage aggregates and plan/lock state
export const getAdminOrganizations = async () => {
  const response = await api.get('/admin/organizations');
  return response.data;
};

// Full detail for a single org
export const getAdminOrganizationDetail = async (orgId) => {
  const response = await api.get(`/admin/organizations/${orgId}`);
  return response.data;
};

// Upsert plan / limits / features / notes
export const updateOrganizationPlan = async (orgId, body) => {
  const response = await api.put(`/admin/organizations/${orgId}/plan`, body);
  return response.data;
};

// Lock (suspend) an org
export const lockOrganization = async (orgId, reason) => {
  const response = await api.post(`/admin/organizations/${orgId}/lock`, { reason });
  return response.data;
};

// Unlock (reinstate) an org
export const unlockOrganization = async (orgId) => {
  const response = await api.post(`/admin/organizations/${orgId}/unlock`);
  return response.data;
};

// Permanently delete a user (used to clean up fake/bot signups)
export const deleteUser = async (userId) => {
  const response = await api.delete(`/admin/users/${userId}`);
  return response.data;
};

// Permanently delete an org and its cascaded data (spam cleanup)
export const deleteOrganization = async (orgId) => {
  const response = await api.delete(`/admin/organizations/${orgId}`);
  return response.data;
};

const superadminApi = {
  getPlatformOverview,
  getAdminOrganizations,
  getAdminOrganizationDetail,
  updateOrganizationPlan,
  lockOrganization,
  unlockOrganization,
  deleteUser,
  deleteOrganization,
};

export default superadminApi;
